/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const InvoiceStatus = {
  Draft: "draft",
  Unpaid: "unpaid",
  PaymentPending: "payment-pending",
  Paid: "paid",
  Overdue: "overdue",
  Canceled: "canceled",
} as const;
export type InvoiceStatus = ClosedEnum<typeof InvoiceStatus>;

/** @internal */
export const InvoiceStatus$inboundSchema: z.ZodNativeEnum<
  typeof InvoiceStatus
> = z.nativeEnum(InvoiceStatus);
/** @internal */
export const InvoiceStatus$outboundSchema: z.ZodNativeEnum<
  typeof InvoiceStatus
> = InvoiceStatus$inboundSchema;
